// RTL levels are odd numbers
export const isRTLLevel = (level: number) => level % 2 === 1;

// LTR levels are even numbers
export const isLTRLevel = (level: number) => level % 2 === 0;
